(function()
{
	"use strict";

	function SharedUI(view)
	{
		this.Container_constructor();
		this.width = cm.app.display.width * 0.5;
		this.height = cm.app.display.height * 0.5;
		this.currentView = view;

		this.pauseContainer = new cjs.Container();
		this.helpBtnContainer = new cjs.Container();
		this.helpContainer = new cjs.Container();
		this.closeHowToContainer = new cjs.Container();

		this.pauseMenuContainer = new cjs.Container();
		this.replayButtonContainer = new cjs.Container();
		this.playButtonContainer = new cjs.Container();
		this.homeButtonContainer = new cjs.Container();
		this.settingsButtonContainer = new cjs.Container();

		this.name = "SharedUI";
		this.addChild(this.pauseContainer, this.helpBtnContainer);
		this.buildUI();
		this.createPauseMenu();
		this.createHelpMenu();
		this.setupShipSettings();
	}

	var p = createjs.extend(SharedUI, cjs.Container);

	p.setupShipSettings = function()
	{
		this.settingShip = new cm.SettingShip();
		this.addChild(this.settingShip);
	};

	p.buildUI = function()
	{


		var pausebg = new cjs.Sprite(cm.Assets.lib.gameSS, "pause-bg").set({name:"pause-bg"}).center();
		var pausebtn = new cjs.Sprite(cm.Assets.lib.gameSS, "pause-btn").set({x:-4, y:0}).center();
		pausebg.on("mousedown", this.buttonHandler, this);
		pausebg.on("mouseover", this.buttonHandler, this);
		pausebg.on("mouseout", this.buttonHandler, this);
		pausebg.on("click", this.buttonHandler, this);
		this.pauseContainer.addChild(pausebg, pausebtn);
		this.pauseContainer.set({x: -this.width + 70, y: -325});
		this.pauseContainer.placeArrow = "up";
		this.pauseContainer.name = "pause-bg";

		var helpbg = new cjs.Sprite(cm.Assets.lib.gameSS, "help-bg").set({name:"help-bg"}).center();
		var helpbtn = new cjs.Sprite(cm.Assets.lib.gameSS, "help-btn").set({x:-1, y: -3}).center();
		helpbg.on("mousedown", this.buttonHandler, this);
		helpbg.on("mouseover", this.buttonHandler, this);
		helpbg.on("mouseout", this.buttonHandler, this);
		helpbg.on("click", this.buttonHandler, this);
		this.helpBtnContainer.addChild(helpbg, helpbtn);
		this.helpBtnContainer.set({x: -this.width + 180, y: -322});
		this.helpBtnContainer.placeArrow = "up";
		this.helpBtnContainer.name = "help-bg";
	};

	p.addButtonToKeyNav = function()
	{
		this.parent.keyNav.buttons.push(this.pauseContainer, this.helpBtnContainer);
		this.parent.keyNav.pauseButtons.push(this.playButtonContainer, this.replayButtonContainer, this.homeButtonContainer, this.settingsButtonContainer);
		this.parent.keyNav.helpButtons.push(this.closeHowToContainer);
	};

	p.buttonHandler = function (e) {
		var sprite;
		if (e.type === "mouseover") {
			if(app.voPlayer)
			this.handleMouseOver(e.target.name);
			sprite = e.target.parent.getChildAt(1);
			cjs.Tween.get(sprite).to({scaleX:1.1, scaleY:1.1}, 150);
		}

		if (e.type === "mouseout") {
			sprite = e.target.parent.getChildAt(1);
			cjs.Tween.get(sprite).to({scaleX:1, scaleY:1}, 150);
		}

		if (e.type === "mousedown") {
			sprite = e.target.parent.getChildAt(1);
			cjs.Tween.get(sprite).to({scaleX:0.9, scaleY:0.9}, 150);
			if(cm.Device.mobile && cjs.Touch.isSupported())
			{
				this.handleMouseOver(e.target.name);
			}
		}

		if(e.type === "click") {
			cm.app.sound.play("click-1");
			sprite = e.target.parent.getChildAt(1);
			this.handleClick(e.target.name);
			cjs.Tween.get(sprite).to({scaleX:1, scaleY:1}, 150, cjs.Ease.backOut);

		}
	};

	p.handleMouseOver = function(name)
	{
		if(app.voPlayer.playing){return;}
		switch(name){
			case "pause-bg":
				app.voPlayer.play("vo-123");
			break;
			case "help-bg":
				app.voPlayer.play("vo-122");
			break;
			case "replay-bg":
				app.voPlayer.play("vo-168");
			break;
			case "replay-btn":
				app.voPlayer.play("vo-165");
			break;
			case "home-btn":
				app.voPlayer.play("vo-170");
			break;
			case "pause-quit":
				app.voPlayer.play("vo-169");
			break;
			case "shipSet-btn":
				app.voPlayer.play("vo-128");
			break;
			case "howtoclose-btn":
				app.voPlayer.play("vo-164");
			break;
		}
	};

	p.handleClick = function(name)
	{
		switch(name){
			case "pause-bg":
				this.pauseMenuContainer.visible = true;
				cm.main.pause = true;
				app.voPlayer.paused = true;
				if(app.voPlayer._currentVO === "vo-11" || app.voPlayer._currentVO === "vo-10" || app.voPlayer._currentVO === "vo-8" || app.voPlayer._currentVO === "vo-9")
				{
					app.voPlayer.stop();
				}
			break;
			case "help-bg":
				this.callHowToPopUp();
			break;
			case "replay-bg":
				this.replayLevel();
			break;
			case "replay-btn":
				cm.ViewControl.current.replayLevel();
			break;
			case "home-btn":
			cm.ViewControl.current.goToView();
			break;
			case "close-how-to-btn":
				this.helpQuit();
			break;
			case "pause-quit":
				this.pauseQuit();
			break;
			case "ship-settings":
			case "shipSet-btn":
				this.settingShip.addChild(this.parent.navArrow);
				this.settingShip.animateIn();
				app.voPlayer.play("vo-118");
			break;
		}
	};

	p.shipSettingsClose = function()
	{
		this.parent.addChild(this.parent.navArrow);
		this.parent.navArrow.visible = false;
	};

	p.createPauseMenu = function()
	{

		var bgGraphic = new cjs.Graphics();
		bgGraphic.f("#000").r(0,0,cm.app.display.width, cm.app.display.height);
		var backGroundShape = new cjs.Shape(bgGraphic);
		backGroundShape.regX = cm.app.display.width * 0.5;
		backGroundShape.regY = cm.app.display.height * 0.5;
		backGroundShape.alpha = 0.4;
		backGroundShape.on("mousedown", this.pauseQuit, this);

		var replayBg = new cjs.Sprite(cm.Assets.lib.gameSS, "big-button-bg").set({name: "replay-btn"}).center();
		var replayButton = new cjs.Sprite(cm.Assets.lib.gameSS, "replay-btn").center();
		replayBg.on("mouseover", this.buttonHandler, this);
		replayBg.on("mouseout", this.buttonHandler, this);
		replayBg.on("mousedown", this.buttonHandler, this);
		replayBg.on("click", this.buttonHandler, this);
		this.replayButtonContainer.addChild(replayBg, replayButton);
		this.replayButtonContainer.x = -83;
		this.replayButtonContainer.name = "replay-btn";
		this.replayButtonContainer.placeArrow = "up";

		var playBg = new cjs.Sprite(cm.Assets.lib.gameSS, "big-button-bg").set({name: "pause-quit"}).center();
		var playButton = new cjs.Sprite(cm.Assets.lib.gameSS, "pause-quit").center();
		this.playButtonContainer.addChild(playBg, playButton);
		this.playButtonContainer.x = -282;
		playBg.on("mouseover", this.buttonHandler, this);
		playBg.on("mouseout", this.buttonHandler, this);
		playBg.on("mousedown", this.buttonHandler, this);
		playBg.on("click", this.pauseQuit, this);
		this.playButtonContainer.name = "pause-quit";
		this.playButtonContainer.placeArrow = "up";

		var homeBg = new cjs.Sprite(cm.Assets.lib.gameSS, "big-button-bg").set({name: "home-btn"}).center();
		var homeButton = new cjs.Sprite(cm.Assets.lib.gameSS, "home-btn").center();
		this.homeButtonContainer.addChild(homeBg, homeButton);
		this.homeButtonContainer.x = 110;
		homeBg.on("mouseover", this.buttonHandler, this);
		homeBg.on("mouseout", this.buttonHandler, this);
		homeBg.on("mousedown", this.buttonHandler, this);
		homeBg.on("click", this.buttonHandler, this);
		this.homeButtonContainer.name = "home-btn";
		this.homeButtonContainer.placeArrow = "up";

		var shipSetBg = new cjs.Sprite(cm.Assets.lib.gameSS, "big-button-bg").set({name: "shipSet-btn"}).center();
		var settingsButton = new cjs.Sprite(cm.Assets.lib.gameSS, "pause-settings").center();
		this.settingsButtonContainer.addChild(shipSetBg, settingsButton);
		this.settingsButtonContainer.x = 300;
		shipSetBg.on("mouseover", this.buttonHandler, this);
		shipSetBg.on("mouseout", this.buttonHandler, this);
		shipSetBg.on("mousedown", this.buttonHandler, this);
		shipSetBg.on("click", this.buttonHandler, this);
		this.settingsButtonContainer.name = "ship-settings";
		this.settingsButtonContainer.placeArrow = "up";

		this.pauseMenuContainer.addChild(backGroundShape, this.replayButtonContainer, this.playButtonContainer, this.homeButtonContainer, this.settingsButtonContainer);
		this.pauseMenuContainer.visible = false;
		this.addChild(this.pauseMenuContainer);

	};


	p.createHelpMenu = function()
	{

		var bgGraphic = new cjs.Graphics();
		bgGraphic.f("#000").r(0,0,cm.app.display.width, cm.app.display.height);
		var backGroundShape = new cjs.Shape(bgGraphic);
		backGroundShape.regX = cm.app.display.width * 0.5;
		backGroundShape.regY = cm.app.display.height * 0.5;
		backGroundShape.alpha = 0.4;
		backGroundShape.on("mousedown", this.helpQuit, this);

		this.howTo1 = this.getHowToFrame(1);
		this.howTo2 = this.getHowToFrame(2);
		this.howTo1.on("mousedown", function(){});
		this.howTo2.on("mousedown", function(){});


		this.howToBg = new cjs.Sprite(cm.Assets.lib.gameSS, "how-to-window").center();

		var howToCloseBg = new cjs.Sprite(cm.Assets.lib.gameSS, "close-how-to-bg").set({name: "howtoclose-btn"}).center();
		var howtoCloseBtn = new cjs.Sprite(cm.Assets.lib.gameSS, "close-how-to-btn").center();
		howToCloseBg.on("mousedown", this.buttonHandler, this);
		howToCloseBg.on("mouseover", this.buttonHandler, this);
		howToCloseBg.on("mouseout", this.buttonHandler, this);
		howToCloseBg.on("click", this.helpQuit, this);
		this.closeHowToContainer.addChild(howToCloseBg, howtoCloseBtn);
		this.closeHowToContainer.y = 270;
		this.closeHowToContainer.name = "close-how-to-btn";
		this.closeHowToContainer.placeArrow = "up";


		this.helpContainer.addChild(backGroundShape, this.howToBg, this.howTo2, this.howTo1, this.closeHowToContainer);

		this.addChild(this.helpContainer);
		this.helpContainer.visible = false;
	};

	p.getHowToFrame = function(num)
	{
		switch (this.currentView)
		{
			case "CollectionView":
				if(num === 1)
					return new cjs.Bitmap(cm.Assets.lib['how-to-space-1']).set({x:2, y:-15}).center();
				else
					return new cjs.Bitmap(cm.Assets.lib['how-to-space-2']).set({x:2, y:-15}).center();
			break;
			case "SortView":
				if(num === 1)
					return new cjs.Bitmap(cm.Assets.lib["how-to-sort-1"]).set({x:2, y:-15}).center();
				else
					return new cjs.Bitmap(cm.Assets.lib["how-to-sort-2"]).set({x:2, y:-15}).center();
			break;
			case "StackView":
				if(num === 1)
					return new cjs.Bitmap(cm.Assets.lib["how-to-stack"]).set({x:2, y:-15}).center();
				else
					return new cjs.Bitmap(cm.Assets.lib["how-to-stack"]).set({x:2, y:-15}).center();
			break;
		}
	};



	p.helpQuit = function()
	{
		this.helpContainer.visible = false;
		cm.main.pause = false;
		cm.app.voPlayer.stop();
		if(this.howToLoop)
			cjs.Tween.removeTweens(this.howToLoop);
		this.howToLoop = null;
		this.unPauseGame();
	};

	p.callHowToPopUp = function()
	{
		this.helpContainer.visible = true;
		cm.main.pause = true;
		this.howTo1.visible = true;
		if(this.currentView === "CollectionView"){
			this.howTo1.on("click", this.nextHelp.bind(this));
			this.closeHowToContainer.visible = false;
			if(cm.Device.mobile && cjs.Touch.isSupported())
				app.voPlayer.play(["vo-19", "vo-19-alt"], this.nextHelp.bind(this));
			else
				app.voPlayer.play("vo-189", this.nextHelp.bind(this));
		}

		if(this.currentView === "SortView"){
			this.howTo1.on("click", this.nextHelp.bind(this));
			this.closeHowToContainer.visible = false;
			if(cm.Device.mobile && cjs.Touch.isSupported())
				app.voPlayer.play(["vo-180", "vo-181"], this.nextHelp.bind(this));
			else
				app.voPlayer.play(["vo-20-alt", "vo-191"], this.nextHelp.bind(this));
		}

		if(this.currentView === "StackView"){
			if(cm.Device.mobile && cjs.Touch.isSupported())
				app.voPlayer.play("vo-183");
			else
				app.voPlayer.play("vo-192");
		}

	};

	p.nextHelp = function()
	{
		this.howTo1.visible = false;
		this.closeHowToContainer.visible = true;
		if(this.currentView === "CollectionView"){
			app.voPlayer.play("vo-20");
		}

		if(this.currentView === "SortView"){
			app.voPlayer.play("vo-182");
		}
	};

	p.loopHelp = function()
	{
		this.howTo1.visible = true;
		this.howToLoop = cjs.Tween.get(this.howTo1, {loop:true}).wait(2000).set({visible: true}).wait(2000).set({visible: false});
	};

	p.unPauseGame = function()
	{
		cm.main.pause = false;
		app.voPlayer.resume();
	};

	p.pauseQuit = function()
	{
		cm.app.sound.play("click-1");
		this.pauseMenuContainer.visible = false;
		this.unPauseGame();
		this.howTo1.removeAllEventListeners();
		this.howTo2.removeAllEventListeners();
	};

	p.endGameQuit = function()
	{
		this.pauseMenuContainer.visible = false;
		this.unPauseGame();
		this.howTo1.removeAllEventListeners();
		this.howTo2.removeAllEventListeners();
	};

	p.resize = function()
	{
		this.width = cm.app.display.width * 0.5;
		this.pauseContainer.x = -this.width + 70;
		this.helpBtnContainer.x = -this.width + 180;
		this.settingShip.backBtnContainer.x = -this.width + 98;
	};

	p._tick = function(e)
	{
		this.Container__tick(e);

	};

	cm.SharedUI = cjs.promote(SharedUI, "Container");
})();
